export const agencyIndustries = [
  { icon: 'retarget', value: 'dmfa', key: 'Digital Marketing Agency' },
  { icon: 'palette', value: 'creative', key: 'Creative Agency' },
  { icon: 'html', value: 'webDevelopment', key: 'Web Development Agency' },
  { icon: 'chat', value: 'consultant', key: 'Consultant' },
  { icon: 'other', value: 'other', key: 'Other' },
];

export const calendarLink = 'https://meetings.hubspot.com/zoe-lazaris/agency?embed=true';
